<template>
  <DsShowcase title="InfiniteScrollPlay" description="Componente de scroll infinito. Emite evento quando o usuário chega ao final da lista.">
    <!-- Uso básico -->
    <section>
      <h2 class="tw:text-base tw:font-semibold tw:mb-1">Uso básico</h2>
      <p class="tw:text-xs tw:opacity-50 tw:mb-4">Emite <code>@load-more</code> ao atingir o final do container</p>
      <div class="tw:max-w-lg tw:h-64 tw:overflow-y-auto tw:border tw:rounded-lg tw:p-4">
        <InfiniteScrollPlay @load-more="onLoadMore">
          <div v-for="i in items" :key="i" class="tw:py-2 tw:border-b tw:text-sm tw:last:border-b-0">
            Item {{ i }}
          </div>
        </InfiniteScrollPlay>
      </div>
      <p class="tw:text-xs tw:mt-2 tw:opacity-50">Total: {{ items.length }} items carregados</p>
    </section>
  </DsShowcase>
</template>

<script lang="ts" setup>
import { ref } from 'vue'
import DsShowcase from '../DsShowcase.vue'
import { InfiniteScrollPlay } from '@/components/atomic'

const items = ref(Array.from({ length: 20 }, (_, i) => i + 1))

function onLoadMore() {
  const start = items.value.length
  items.value.push(...Array.from({ length: 10 }, (_, i) => start + i + 1))
}
</script>
